import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { searchTickets } from '../../../api/tickets'
import { getSearchActiveStatus } from '../../../../utils'


export const fetchTicketList = createAsyncThunk('tickets/getAllTickets', async (params) => {
    const response = await searchTickets(params)
    console.log("searchTickets response ==>", response)
    return response.data
})

export const ticketSlice = createSlice({
    name : "tickets/getAllTickets",
    initialState : {
        loading: false,
        isInitialLoad: true,
        ticketList: [],
        paginationParams: {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "ticketList",
            searchBy: "all",
            searchText: "",
            statusId: 1,
            dateType: "createdAt",
            assignToMe : true,
            openStatus : true,
            procmartUser : true
        },
        searchOptions: [],
        isSearchVisible: false,
        isSearchActive: true,
        searchConfig: []
    },
    reducers: {
        setInitialLoad: (state, action) => {
            state.isInitialLoad = action.payload
        },
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
            const parsedState = JSON.parse(JSON.stringify(state))
            
            const isSearchActive = getSearchActiveStatus(parsedState.searchParams, parsedState.searchConfig)
            
            state.isSearchActive = isSearchActive
        },
        updateTicketsData: (state, action) => {
            state.ticketList = action.payload
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setSearchConfig: (state, action) => {
            state.searchConfig = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(
            fetchTicketList.fulfilled, (state, action) => {
                state.loading = false 
                state.ticketList = action.payload?.data
                state.paginationParams.pageNo = action.payload.pageNo 
                state.paginationParams.recordsPerPage = action.payload.recordsPerPage 
                if(action.payload.totalRecords || action.payload.totalRecords === 0){
                    state.paginationParams.totalRecords =  action.payload?.totalRecords
                }

                if(state.ticketList && state.ticketList.length){
                    state.isSearchVisible = false
                }
            }
        )
        .addCase(
            fetchTicketList.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchTicketList.rejected, (state, action) => {
                state.loading = false
            }
        )
    }

})

export const { updateSearchParams, updateSearchOptions, setInitialLoad, updateTicketsData, setIsSearchVisible, setSearchConfig } = ticketSlice.actions

export default ticketSlice.reducer